import React from "react";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

export default function DateControls({
  viewMode,
  displayDateRange,
  onChangeView,
  onToggleFilters,
  title = "PEARLI Well-Being Assessment",
  subtitle = "Tracking Participant Well-Being Across PEARLI Domains",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box>
        <Typography variant="h5" fontWeight={700}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {displayDateRange}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mt: { xs: 2, sm: 0 },
        }}
      >
        <Button
          size="small"
          variant={viewMode === "current" ? "contained" : "outlined"}
          onClick={() => onChangeView("current")}
        >
          Current Month
        </Button>

        <Button
          size="small"
          variant={viewMode === "range" ? "contained" : "outlined"}
          onClick={() => onChangeView("range")}
        >
          Month Range
        </Button>

        <Tooltip title="Filter values">
          <IconButton
            size="small"
            onClick={onToggleFilters}
            sx={{
              borderRadius: 1.5,
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <FontAwesomeIcon icon={faFilter} style={{ fontSize: 14 }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}
